module.exports = __webpack_public_path__ + "static/media/delete.c6a1eaf2.svg";